import { DEVELOPMENT, STAGING } from 'constants';

const shouldLogObjects = DEVELOPMENT || STAGING || new URLSearchParams(window.location.search).get('log_objects') === 'true';
const isObjectLike = (value) => value !== null && typeof value === 'object';
const DEFAULT_TAG_STYLE = 'background:#6b7280;color:#fff;padding:2px 6px;border-radius:4px;font-weight:600;';
const PAUL_TAG_STYLE = 'background:#7c3aed;color:#fff;padding:2px 6px;border-radius:4px;font-weight:600;';
const FRONT_TAG_STYLE = 'background:#0ea5e9;color:#fff;padding:2px 6px;border-radius:4px;font-weight:600;';
const SUPERADMIN_TAG_STYLE = 'background:#f59e0b;color:#fff;padding:2px 6px;border-radius:4px;font-weight:600;';
const COMPUTE_PREVENTED_TAG_STYLE = 'background:#f59e0b;color:#fff;padding:2px 6px;border-radius:4px;font-weight:600;';
const COMPUTE_WILL_TAG_STYLE = 'background:#f59e0b;color:#fff;padding:2px 6px;border-radius:4px;font-weight:600;';
const MESSAGE_STYLE = 'color:inherit;';
const SOCKET_TAG_STYLE = 'background:#e1e37b;color:#fff;padding:2px 6px;border-radius:4px;font-weight:600;';

const normalizeTag = (tag) => {
  return String(tag || 'app').trim();
};

const isTagCandidate = (value) => {
  return typeof value === 'string' && /^[a-z0-9_-]+$/i.test(value);
};

const getTagStyle = (tag) => {
  const normalizedTag = String(tag).toUpperCase();
  switch (normalizedTag) {
    case 'PAUL':
      return PAUL_TAG_STYLE;
    case 'COMPUTE_PREVENTED':
      return COMPUTE_PREVENTED_TAG_STYLE;
    case 'WILL_COMPUTE':
      return COMPUTE_WILL_TAG_STYLE;
    case 'FRONT':
      return FRONT_TAG_STYLE;
    case 'SUPERADMIN':
      return SUPERADMIN_TAG_STYLE;
    case 'SOCKET':
      return SOCKET_TAG_STYLE;
    default:
      return DEFAULT_TAG_STYLE;
  }
};

const buildStyledArgs = (tag, message, payload) => {
  return [`%c[${tag}]%c ${message}`, getTagStyle(tag), MESSAGE_STYLE, ...payload];
};

export const igLogger = {
  dir: (...params) => {
    console.dir(...params);
  },
  log: (tagOrMessage, messageOrPayload, ...restPayload) => {
    let tag = 'app';
    let message = tagOrMessage;
    let payload = [];

    if (isTagCandidate(tagOrMessage) && typeof messageOrPayload === 'string') {
      tag = normalizeTag(tagOrMessage);
      message = messageOrPayload;
      payload = restPayload;
    } else if (typeof messageOrPayload !== 'undefined') {
      payload = [messageOrPayload];
    }

    if (!shouldLogObjects) {
      const nonObjectPayload = payload.filter((value) => !isObjectLike(value));
      console.log(...buildStyledArgs(tag, message, nonObjectPayload));
      return;
    }

    console.log(...buildStyledArgs(tag, message, payload));
  },
  error: (...params) => {
    console.error(...params);
  },
};

if (typeof window !== 'undefined') {
  window.igLogger = window.igLogger || igLogger;
}

export default igLogger;
